import { ref } from 'vue'
import { defineStore } from 'pinia'
import useJwt from '@core/auth/jwt/useJwt'

const userName = ref('')
const userAbv = ref('')
const userFirstName = ref('')
const userEmail = ref('')
const userType = ref('')
const organization = ref('')
const dashboard = ref('')
const demo = ref('')
const plan = ref('')
const communicationList = ref([])

useJwt.getSession().then(session => {
  const { user } = { user: { name: '', ...session.user } }
  userName.value = user.name
  userAbv.value = user.name.split(' ').map(item => item.substr(0, 1)).join('')
  userFirstName.value = user.name.split(' ').shift()
  userEmail.value = user.email
  userType.value = user.type
  organization.value = user.organization
  dashboard.value = user.dashboard
  demo.value = user.demo
  plan.value = user.plan
  communicationList.value = user.communication
})

export default defineStore('app', {
  state: () => ({
    userName,
    userAbv,
    userFirstName,
    userEmail,
    userType,
    organization,
    dashboard,
    demo,
    plan,
    communicationList,
    count: {},
    expectedReceipt: [],
    companiesByMonth: [],
    paymentGateway: [],
    paymentGatewayLoading: true,
  }),
  actions: {
    async userChangePassword(data) {
      const response = await useJwt.axios.post('/users/changePassword', data)
      return response
    },
    async statsCount() {
      const response = await useJwt.axios.get('/stats/count')
      this.count = response.data
    },
    async fetchPaymentGateway(data) {
      setTimeout(() => {
        const { amount, paymentMethod } = data

        this.paymentGateway = [
          {
            id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
            transactionId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
            txId: 'string',
            dictKey: 'string',
            message: 'string',
            revisionNumber: 2,
            status: 'ACTIVE',
            qrCode: paymentMethod === 'PIX' ? {
              // eslint-disable-next-line max-len
              emv: '00020101021226860014BR.GOV.BCB.PIX2564spi-h.itau.com.br/pix/qr/v2/b7b0640b-87e6-4f10-ac8c-6eba73e268655204000053039865802BR5912Cristal Conn6009SAO PAULO62070503***6304A0D1',
              // eslint-disable-next-line max-len
              base64Image: 'iVBORw0KGgoAAAANSUhEUgAAAPoAAAD6AQAAAACgl2eQAAACw0lEQVR4Xu2WQXIjIRAE4SPw/1/sU+Aj4MxG4ZF0cPhg9V6GXcsjyI2o7a4upuyf17/yvvO2buCsGzjrBs76HTBKqXvUufrqe9W59+ozNvMAdiaL3VVHBatziM1MwK9ztcKx2+p9MKnAVJ37e5W+Suv/AUBipz9FoTNKlwz4tSGNQ590T2wmAvpTx7ysd1e/n/8xcBaGbdbIo9b6YzcLGFZoVcWyenhmtANlAXvF8+DDCXaMNXAq4LgOR5dxCetYK2MkE0AeNh3srbCuVhlWLA+gUnbJU7LLEtUomidZAJsrzgkxWB7cnPErC4hucUh+alr/gXlyNSsB0C6YpDXlKRjjvjQrAygmOeNrdnWnmBw1ShKBGNNo0iI2mgWycdfwZgA2RkVcZMOxYXibGZIIGFuqo1kIi2I5SGpMA7QK/lhdjVSs2TV9lAjEy0V4xpoVi9Q6SlWZCJTqZ/Ve0zHOTY0UywMeg+IDQTp1kA+JwAzPcoppwzsm6oyGpQH7SAomaDKVnWt4E4Bhs8aJ0WjYGeGrWQmA+VVPsbxS6tw6NjybBhBZ1VlVpH2CK3LX/+LzgMnd1eVbr+++EWg7VGYBSttOiym6nSB/9tWsBMDN7cBQKs+0q3gqwEuNbzgR5SRpdycMlAfgj0itxqekMP1Dah6AGuTNUxlsY7ITaE+F+jzgLcJ2a9YKwfIUzGnKA2JoEck+96t3XORYKhD6muf+KNA/V7MSAL7UE106duriSJLvZmUAHHRLNU1Q/ErlGOVnV38coCvDumAWusQRSNwriYDL7EKaKL3DvdooEQhFyxgdzqxdo1l0KxHQIlTLYlV/8+HDU4glAGrjlRfznmZFjrykfQ5AqTAuZRrFAkGoMRcoJriVQlqAKxfg7/RKp0YIxDsM8zz3SxZwTNsRW3q4pcc7Bo95wE/rBs66gbNu4Kw/AL4AfV8/UZGxnQcAAAAASUVORK5CYII=',
            } : null,
            fileURL: paymentMethod === 'Boleto' ? 'https://maistecnologias.com.br/' : null,
            calendar: {
              createdAt: '2023-05-10T19:02:24.170Z',
            },
            value: amount,
          },
        ]
        this.paymentGatewayLoading = false
      }, 2000)
    },
    async getCompaniesCount() {
      const response = await useJwt.axios.get('/backoffice/dashboard/companiesCount')
      this.companiesCount = response.data.companiesCount
    },
    async getExpectedAmount() {
      const response = await useJwt.axios.get('/backoffice/dashboard/expectedAmount')
      this.expectedAmount = response.data.expectedAmount
    },
    async getExpectedReceipt() {
      const response = await useJwt.axios.get('/backoffice/dashboard/expectedReceipt')
      this.expectedReceipt = response.data
    },
    async getCompaniesByMonth() {
      const response = await useJwt.axios.get('/backoffice/dashboard/companiesByMonth')
      this.companiesByMonth = response.data
    },
  },
})
